<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-full"
      >
        Name
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Type
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
      >
        Size for display
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
      >
        Size range for display
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
      >
        Size for search
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
      >
        Size range for search
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
